module.exports = new __parcel__URL__("beetlejuice-glenn-shadix.507615e4.gif").toString();